<template>
  <div class='ilots'>
    <v-breadcrumb/>
    <div class='actions-table flex flex-end'>
      <button v-can:edit-exploitation class='primary-action' type='button' @click='createSimulation'>Ajouter une simulation</button>
    </div>
    <table class='cursor-pointer'>
      <thead>
        <tr>
          <td>Nom de la simulation</td>
          <td>Nombre d'îlots</td>
          <td>Nombre de scénario</td>
          <td>Détails des îlots</td>
          <td class="has-tooltip" v-can:edit-exploitation v-tooltip="{content: '<header>Dupliquer la simulation</header>'}"/>
          <td class="has-tooltip" v-can:edit-exploitation v-tooltip="{content: '<header>Supprimer la simulation</header>'}"/>
        </tr>
      </thead>
      <transition-group tag='tbody' name='fade'>
        <tr v-for='simulation in simulations' :key='simulation.id_simulation'>
          <td>
            <router-link :to='{ name: "simulation", params: { idExploitation: simulation.id_exploitation, idSimulation: simulation.id_simulation }}'>{{ simulation.nom }}</router-link>
            <button class='align-icon-right action-icon edit-btn has-tooltip' @click.prevent='renameSimu(simulation.id_simulation, simulation.nom)' v-tooltip="{content: '<header>Renommer la simulation</header>'}"/>
          </td>
          <td>{{ simulation.nbilot }}</td>
          <td>{{ simulation.nbscenario }}</td>
          <td>{{ simulation.detail }}</td>
          <td class='align-center' v-can:edit-exploitation>
            <button class='action-icon duplicate-btn has-tooltip' @click.prevent='duplicateSimulation(simulation)' v-tooltip="{content: '<header>Dupliquer la simulation</header>'}"/>
          </td>
          <td class='align-center' v-can:edit-exploitation>
            <button class='action-icon delete-btn has-tooltip' @click.prevent='deleteSimu(simulation.id_simulation, simulation.nom)' v-tooltip="{content: '<header>Supprimer la simulation</header>'}"/>
          </td>
        </tr>
      </transition-group>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Mixinsimulation from '@/mixins/simulation'

export default {
  name: 'ExploitationSimulationList',

  mixins: [Mixinsimulation],

  props: {
    idExploitation: {
      type: String,
      required: true
    }
  },

  computed: {
    simulations () {
      return this.$store.getters.simulations
    }
  },

  methods: {
    ...mapActions(['removeSimulation', 'renameSimulation']),
    ...mapActions('confirm', ['confirm']),
    ...mapActions('prompt', ['prompt']),

    deleteSimu (idSimulation, nomSimulation) {
      this.confirm({
        title: 'Suppression Simulation',
        message: 'Êtes vous-sûr de vouloir supprimer la simulation ' + nomSimulation + ' ?',
        okText: 'Supprimer'
      }).then(confirmation => {
        if (confirmation) {
          this.removeSimulation({
            idExploitation: this.idExploitation,
            idSimulation
          }).then(() =>
            this.$store.dispatch('success', 'Simulation supprimée')
          )
        }
      })
    },

    renameSimu (idSimulation, oldName) {
      this.prompt({
        title: 'Renommer Simulation',
        label: 'Nom de la simulation',
        okText: 'Renommer',
        text: oldName
      }).then((resultat) => {
        if (resultat !== false) {
          this.renameSimulation({
            idExploitation: this.idExploitation,
            idSimulation,
            nom: resultat
          }).then(() =>
            this.$store.dispatch('success', 'Simulation renommée')
          )
        }
      })
    }
  }
}
</script>
